import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import './MySubscriptionPage.css';
import RightArrowIcon from '../../assets/images/path-to-right-arrow-icon.svg';
import '../landingpage/LandingPageStyles';
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { Row, Col, notification } from "antd";
import { useNavigate } from "react-router-dom";
import goBackButton from "../../assets/images/Go_Back.svg";
import { latestSubscription } from '../../api/password';

const MySubscriptionPage = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState('');
  const [subscriptionType, setSubscriptionType] = useState('');
  const [subscriptionStatus, setSubscriptionStatus] = useState('');
  const navigate = useNavigate();

  function capitalizeFirstLetter(string) {
    if (typeof string !== 'string' || string.length === 0) {
      return string;
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  useEffect(() => {
    const fetchSubscriptionData = async () => {

      try {
        const response = await latestSubscription();

        if (response.error) {
          notification.error({ message: 'My Subscription Error', description: "Error Fetching Your Subscription Details", duration: 10 });
        }

        setSubscriptionType(response.subscriptionDetails.planName);
        const capitalizedStatus = capitalizeFirstLetter(response.subscriptionDetails.status);
        setSubscriptionStatus(capitalizedStatus);
        setSubscriptionId(response.subscriptionDetails.stripeSubscriptionId);
      } catch (error) {
        notification.error({ message: ' My Subscription Error', description: error.message, duration: 10 });
      }
    };

    fetchSubscriptionData();
  }, [navigate]);

  function handleGoBackButton() {
    navigate("/landing-page");
  }


  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease",
    opacity: isDrawerOpen ? "0.5" : "1",
    pointerEvents: isDrawerOpen ? "none" : "auto",
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  function handleManageSubscriptionClick() {
    navigate('/manage-sub', { state: { subscriptionId, subscriptionStatus, subscriptionType } });
  }

  return (
    <div style={{ minHeight: "100dvh", background: "#fefcfe" }}>
      <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
        <Row
          justify={{
            xs: "space-around",
            md: "space-around",
            lg: "space-between",
          }}
          style={{ marginBottom: 20 }}
        >
          <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
            <UserHeader setDrawer={openDrawer} />
          </Col>
          {isDrawerOpen && (
            <Col span={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}
          <Col flex="10%" className="go-back-button">
            <button onClick={handleGoBackButton} className="button-styling">
              <img src={goBackButton} alt="Go Back Button" />
            </button>
          </Col>
        </Row>
        <div className="subscription-container">
          <h1 className="title">My Subscription</h1>

          <div className="mysubscription-section">
            <h2 className="section-title">SUBSCRIPTION DETAILS</h2>
            <div className="subscription-info">
              <label className="label">Your Subscription</label>
              <div className="subscription-type">
                <span className="type-text">{subscriptionType}</span>
                <div onClick={handleManageSubscriptionClick} className="manage-link">Manage Subscription</div>
              </div>
              <label className="label">Status</label>
              <div className={`status ${subscriptionStatus.toLowerCase()}`}>
                <span>{subscriptionStatus === 'Trialing' ? 'Active' : subscriptionStatus}</span>
              </div>
            </div>
          </div>

          <div className="payment-section">
            <h2 className="section-title">PAYMENT INFORMATION</h2>
            <div className="payment-info">
              <RouterLink to="/payment-methods" className="payment-link">
                <div className="icon payment-icon"></div>
                <span>Payment Methods</span>
                <img src={RightArrowIcon} alt="Right Arrow" className="arrow-icon" />
              </RouterLink>
              <RouterLink to="/billing-history" className="payment-link">
                <div className="icon billing-icon"></div>
                <span>Billing History</span>
                <img src={RightArrowIcon} alt="Right Arrow" className="arrow-icon" />
              </RouterLink>
            </div>
          </div>
        </div>
      </Col>
    </div>
  );
};

export default MySubscriptionPage;
